import {
  BatteryCharging20,
  CleaningServices,
  Stop,
  Error,
  EvStation,
} from "@mui/icons-material";

// Button styling functions
export const getButtonBackgroundColor = (status) => {
  switch (status) {
    case "start":
      return "#1fcf1f";
    case "stop":
    case "stopping":
      return "#f44336";
    case "resume":
      return "#ffff00ff";
    case "disabled":
      return "#d6d6d6";
    default:
      return "#f5f5f5";
  }
};

export const getButtonTextColor = (status) => {
  switch (status) {
    case "start":
      return "#2b5c2c";
    case "stop":
      return "#82241e";
    case "resume":
      return "rgb(125, 125, 22)";
    case "disabled":
      return "#d6d6d6";
    default:
      return "#f5f5f5";
  }
};

// Status bar styling functions
export const getStatusBarBackgroundColor = (state) => {
  switch (state) {
    case "charging":
      return "#feffdc"; // Light yellow
    case "charged":
      return "#feffdc"; // Light yellow
    case "cleaning":
      return "#e8f5e8"; // Light green
    case "stopped":
      return "#ffebee"; // Light red
    case "error":
      return "#ffebee"; // Light red
    case "returning":
      return "#fff3e0"; // Light orange
    case "busy":
      return "#e3f2fd"; // Light blue: station working (mop wash, dust emptying)
    case "drying":
      return "#e3f2fd"; // Light blue: mop drying on the station (start allowed)
    default:
      return "#f8f9fa"; // Light gray
  }
};

export const getStatusBarBorderColor = (state) => {
  switch (state) {
    case "charging":
      return "#d8db3a"; // Yellow
    case "charged":
      return "#d8db3a"; // Yellow
    case "cleaning":
      return "#4caf50"; // Green
    case "stopped":
      return "#f44336"; // Red
    case "error":
      return "#f44336"; // Red
    case "unavailable":
      return "#9e9e9e"; // Gray
    case "returning":
      return "#ff9800"; // Orange
    case "busy":
    case "drying":
      return "#2196f3"; // Blue
    default:
      return "#e0e0e0"; // Gray
  }
};

// Icon functions
export const getStatusIcon = (state) => {
  switch (state) {
    case "charging":
      return <BatteryCharging20 />;
    case "cleaning":
      return <CleaningServices />;
    case "stopped":
      return <Stop />;
    case "error":
      return <Error />;
    case "returning":
    case "busy":
    case "drying":
      return <EvStation />;
    case "Unavailable":
      return <Error />;
    default:
      return <Stop />;
  }
};

// Style objects that can be reused
export const buttonStyles = {
  base: {
    mt: "auto",
    textTransform: "uppercase",
    color: "#000000",
    fontWeight: "bold",
    height: 52,
    minHeight: 52,
    fontSize: "0.82rem",
    px: 1,
  },
  hover: {
    filter: "brightness(0.9)",
  },
};

export const modalStyles = {
  container: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    outline: "none",
    "&:focus": {
      outline: "none",
    },
    "&:focus-visible": {
      outline: "none",
    },
    p: 4,
    textAlign: "center",
  },
  loading: {
    minWidth: 300,
  },
  support: {
    minWidth: 400,
    maxWidth: 500,
    textAlign: "left",
  },
};

export const sidebarStyles = {
  container: {
    width: 250,
    p: 3,
    borderLeft: "1px solid #e0e0e0",
    backgroundColor: "#f8f9fa",
  },
  languageButton: {
    minWidth: "auto",
    px: 1,
    color: "#0ea8e5",
    borderColor: "#0ea8e5",
    "&:hover": {
      backgroundColor: "#0ea8e52a",
    },
  },
  driveToDockButton: {
    py: 1.5,
    color: "#ffffff",
    backgroundColor: "#ff9800",
    borderColor: "#ff9800",
    "&:hover": {
      backgroundColor: "#eb8e03",
      borderColor: "#eb8e03",
      color: "#ffffff",
    },
  },
  supportButton: {
    py: 1.5,
    color: "#ffffff",
    backgroundColor: "#51acf7",
    "&:hover": {
      backgroundColor: "#3390e3",
    },
  },
  supportButtonError: {
    backgroundColor: "#ffebee",
    borderColor: "#f44336",
    color: "#f44336",
    boxShadow: "0 0 10px rgba(244, 67, 54, 0.5)",
    "&:hover": {
      backgroundColor: "#ffcdd2",
      borderColor: "#f44336",
      color: "#f44336",
    },
  },
  settingsButton: {
    py: 1.5,
    color: "#ff9800",
    backgroundColor: "#ffffff",
    borderColor: "#ff9800",
    "&:hover": {
      backgroundColor: "#fff3e0",
      borderColor: "#f57c00",
      color: "#f57c00",
    },
  },
  pulseAnimation: {
    "@keyframes pulse": {
      "0%": {
        transform: "scale(1)",
        boxShadow: "0 0 10px rgba(244, 67, 54, 0.5)",
      },
      "50%": {
        transform: "scale(1.05)",
        boxShadow: "0 0 20px rgba(244, 67, 54, 0.8)",
      },
      "100%": {
        transform: "scale(1)",
        boxShadow: "0 0 10px rgba(244, 67, 54, 0.5)",
      },
    },
  },
};
